import { Modal } from 'ui/Modal';
import { Box } from 'ui/Box';
import { Button } from 'components/Button';
import { Typography } from 'ui/Typography';
import { FC } from 'react';
import { clsx } from 'clsx';

export interface DeleteModalProps {
  title: string;
  open: boolean;
  disabled?: boolean;
  onClose: () => void;
  onConfirm: () => void;
  className?: string;
}

export const DeleteModal: FC<DeleteModalProps> = ({
  title,
  open,
  disabled = false,
  onClose,
  onConfirm,
  className,
}) => {
  return (
    <Modal open={open} onClose={disabled ? undefined : onClose}>
      <Box
        className={clsx(
          'absolute left-1/2 top-1/2 w-full max-w-max -translate-x-1/2 -translate-y-1/2 transform px-4',
          className
        )}
      >
        <Box className={'w-full rounded-2xl bg-white px-6 py-8'}>
          <Box className="mb-8 flex justify-center">
            <Typography variant="pSemiboldBlack" align="center">
              {title}
            </Typography>
          </Box>
          <Box className="flex justify-center gap-4">
            <Button
              variantType="outlined"
              onClick={onClose}
              disabled={disabled}
            >
              <Typography>Cancel</Typography>
            </Button>
            <Button
              variantType="alertFilled"
              onClick={onConfirm}
              disabled={disabled}
            >
              <Typography>Delete</Typography>
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};
